import { Languages, Undo2 } from '../../../../icons';
import { Button } from '../../../ui/button';

export function ScriptTranslateToggle({
  showingTranslation,
  detectedLanguage,
  onToggle,
}: {
  showingTranslation: boolean;
  detectedLanguage?: string;
  onToggle: () => void;
}) {
  return (
    <div className="flex items-center justify-between gap-2">
      <span className="uppercase text-body-sm-regular text-[#737373]">
        {showingTranslation
          ? `Translated from ${detectedLanguage ?? 'original'}`
          : `Original: ${detectedLanguage ?? 'unknown'}`}
      </span>
      <Button
        type="button"
        variant="outline"
        onClick={onToggle}
        className="h-auto rounded-full px-3 py-1.5 text-caption-medium"
      >
        {showingTranslation ? (
          <>
            <Undo2 size={13} className="mr-1.5" /> Show original
          </>
        ) : (
          <>
            <Languages size={13} className="mr-1.5" /> Translate to English
          </>
        )}
      </Button>
    </div>
  );
}
